// Extend jQuery with Select2 — avoids needing @types/select2
interface JQuery {
    select2(options?: any): JQuery;
    select2(method: string, ...args: any[]): any;
}

function IncreaseModal(scriptName?: string) {
    $("#ScriptModal .modal-dialog").addClass("modal-lg");

    // Show the monospace script-name tag in the header if provided
    if (scriptName) {
        $("#ScriptModalTitleTag").text(scriptName).show();
    } else {
        // Try to read it from the hidden input rendered by the partial
        var hiddenName = $("#scriptNameHidd").val() as string;
        if (hiddenName) {
            $("#ScriptModalTitleTag").text(hiddenName).show();
        } else {
            $("#ScriptModalTitleTag").hide().text('');
        }
    }
}

function DecreaseModal() {
    $("#ScriptModal .modal-dialog").removeClass("modal-lg");
    $("#ScriptModalTitleTag").hide().text('');
    $('#ScriptModal').modal('hide');
}

$("#ScriptModal").on("hidden.bs.modal", () => {
    DecreaseModal();
});

module ScriptsPerCustomer {
    export function Init() {
        var idCompany = $('#hdnIdCompany').val() || -1;
        var idVersion = $('#hdnIdVersion').val() || 0;

        var dataTableSettings: DataTables.Settings = {
            pageLength: 25,
            scrollY: '60vh',
            order: [[0, 'desc']],
            columns: [
                { data: 0, title: 'Naziv' },
                { data: 1, title: 'Datum' },
                { data: 2, title: 'Korisnik' },
                { data: 3, title: 'Fat' },
                { data: 4, title: 'Uat' },
                { data: 5, title: 'Prod' },
                { data: 6, title: 'Task' },
                { data: 7, title: 'Tip' },
                { data: 8, title: 'Schema' },
                { data: 9, title: 'Naziv paketa' },
                { data: 10, title: 'Opis' },
                { data: 11, title: 'Param' },
                { data: 12, title: 'App' },
                { data: 13, title: 'Akcija' }
            ]
        };

        var columnDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: [3, 4, 5, 6, 11, 12, 13],
                orderable: false
            },
            {
                targets: [3, 4, 5],
                width: '36px',
                className: 'spc-td-icon'
            },
            {
                targets: [10],
                className: 'text-left'
            },
            {
                targets: [13],
                width: '110px',
                className: 'spc-td-actions'
            }
        ];

        Common.DataTableCustom.Init(
            "scriptTable",
            dataTableSettings,
            columnDef,
            `/Script/ListData/${idCompany}/${idVersion}`
        );

        Common.FilterBar.Init(function () {
            var company = $("#companyList").val() || -1;
            var version = $("#versionList").val() || 0;
            if ($.fn.dataTable.isDataTable('#scriptTable')) {
                $('#scriptTable').DataTable().ajax.url(`/Script/ListData/${company}/${version}`).load();
            }
        }, { applyBtnId: 'setFilters', watchSelects: true });

        $("#btnAddNewScript").on("click", function () {
            Dialog.OpenModal('<i class="fas fa-plus-circle" style="color:#378ADD;margin-right:8px;"></i>Nova skripta', 'Spremi', '/Script/Create');
        });

        $('#scriptTable').on('click', '.script-per-customer-edit', function () {
            var scriptName = $(this).data("script-name");
            var idScript = $(this).data("id-script");
            Dialog.OpenModal(`Izmjena skripte: ${scriptName}`, 'Izmjeni', `/Script/Edit/${idScript}`);
        });

        $('#scriptTable').on('click', '.script-per-customer-delete', function () {
            var idScript = $(this).data("id-script");
            Dialog.OpenModal('Brisanje skripte', 'Obriši', `/Script/Delete/${idScript}`);
        });

        $('#scriptTable').on('click', '.script-per-customer-details', function () {
            var idScript = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', `/Script/Details/${idScript}`);
        });

        $('#scriptTable').on('click', '.script-per-customer-preview', function () {
            var idScript = $(this).data("id-script");
            var canEdit = $(this).data("can-edit") || 0;
            Dialog.OpenDetailsModal('Pregled skripte', `/Script/Preview/${idScript}?canEdit=${canEdit}`, 'modal-xxl');
        });

        // Handle edit button click from preview modal
        $(document).on('click', '#btnEditScript', function() {
            var idScript = $(this).data("id-script");
            // Close preview modal and open editor modal
            $("#ScriptDetailsModal").modal("hide");
            setTimeout(function() {
                Dialog.OpenDetailsModal('Uredi skriptu', `/Script/Editor/${idScript}`, 'modal-xxl');
            }, 300);
        });

        $("#btnGenerateScripts").on("click", function () {
            ScriptsPerCustomer.GenerateScripts();
        });
    }

    export function RefreshTableData() {
        Common.DataTableCustom.RefreshTableData('scriptTable');
    }

    export function DownloadScript(scriptVersion: string, scriptName: string) {
        window.location.href = `/Script/DownloadFile/${scriptVersion}/${scriptName}`;
    }

    export function GenerateScripts() {
        PlsWait.ShowLoader(true);
        var url: string = '/GenerateScripts/';
        var idCompany: string = $("#companyList").val() as string;
        var idVersion: string = $("#versionList").val() as string;

        window.location.href = `${url}${idCompany}/${idVersion}/FAT/1$1`;
    }
}

module ScriptsPerCustomer.Create {

    export interface ISelectedNodes {
        parentNode: string,
        childrenNodes: string[]
    }

    export interface IScriptData {
        idScript: number,
        customers: ISelectedNodes[],
        schema: string,
        scriptName: string,
        description: string,
        projects: number[],
        task: string,
        scriptChangeset: string,
        type: string,
        fileContainer: string,
        scriptVersion: number,
        action: string,
        isParamScript: boolean,
        idSchema: number,
        isReleaseNotice: boolean,
        releaseNotice: string
    }

    var arrayOfSelectedNodes: ISelectedNodes[];
    var _droppedFile: File | null = null;
    var _editorTextContent: string = '';


    interface ITreeUIState {
        label: string;
        open: boolean;
        envs: { [env: string]: boolean };
        locked: { [env: string]: string };
        selected: boolean;
    }

    var treeUIState: { [key: string]: ITreeUIState } = {};
    var treeUIEnvs: string[] = [];

    function renderClientGrid(): void {
        var grid = document.getElementById('spcClientGrid');
        if (!grid) return;
        grid.innerHTML = '';

        Object.keys(treeUIState).forEach(function (key) {
            var s = treeUIState[key];
            var openEnvs = treeUIEnvs.filter(e => !s.locked[e]);
            var lockedCount = treeUIEnvs.length - openEnvs.length;
            var selCount = openEnvs.filter(e => s.envs[e]).length;
            var allSel = lockedCount === 0 && selCount === treeUIEnvs.length;
            var partSel = !allSel && (selCount > 0 || lockedCount > 0);

            var node = document.createElement('div');
            node.className = 'spc-client-node';

            var hdr = document.createElement('div');
            hdr.className = 'spc-client-header'
                + (allSel ? ' selected' : '')
                + (partSel ? ' partial' : '')
                + (s.open ? ' open' : '');

            hdr.innerHTML =
                '<span class="spc-expand-arrow">' +
                '<svg viewBox="0 0 10 10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                '<polyline points="3,2 7,5 3,8"/>' +
                '</svg>' +
                '</span>' +
                '<span class="spc-client-name">' + s.label + '</span>';

            // Arrow — toggle expand/collapse
            hdr.querySelector('.spc-expand-arrow').addEventListener('click', function (ev: Event) {
                ev.stopPropagation();
                treeUIState[key].open = !treeUIState[key].open;
                renderClientGrid();
            });

            // Header click — select/deselect all envs for this client
            hdr.addEventListener('click', function () {
                if (openEnvs.length === 0) return;
                var newVal = selCount !== openEnvs.length;
                openEnvs.forEach(e => treeUIState[key].envs[e] = newVal);
                renderClientGrid();
            });

            node.appendChild(hdr);

            var envListEl = document.createElement('div');
            envListEl.className = 'spc-env-list' + (s.open ? ' open' : '');

            treeUIEnvs.forEach(function (env) {
                var item = document.createElement('div');

                if (s.locked[env]) {
                    item.className = 'spc-env-item locked';
                    item.title = 'Pušteno ' + s.locked[env];
                    item.innerHTML =
                        '<span class="spc-env-dot"></span>' +
                        '<span class="spc-env-badge">' + env + '</span>' +
                        '<span class="spc-env-locked-date">pušteno ' + s.locked[env] + '</span>';
                    item.addEventListener('click', function (ev: Event) {
                        ev.stopPropagation();
                    });
                    envListEl.appendChild(item);
                    return;
                }

                item.className = 'spc-env-item' + (s.envs[env] ? ' selected' : '');
                item.innerHTML =
                    '<span class="spc-env-dot"></span>' +
                    '<span class="spc-env-badge">' + env + '</span>';
                item.addEventListener('click', function (ev: Event) {
                    ev.stopPropagation();
                    treeUIState[key].envs[env] = !treeUIState[key].envs[env];
                    renderClientGrid();
                });
                envListEl.appendChild(item);
            });

            node.appendChild(envListEl);
            grid.appendChild(node);
        });

        updateClientSummary();
        updateEditorButtonVisibility();
    }

    function updateClientSummary(): void {
        var parts: string[] = [];
        Object.keys(treeUIState).forEach(function (key) {
            var s = treeUIState[key];
            var sel = treeUIEnvs.filter(e => s.envs[e] && !s.locked[e]);
            var locked = treeUIEnvs.filter(e => !!s.locked[e]);
            if (sel.length === treeUIEnvs.length) parts.push(s.label);
            else if (sel.length > 0 || locked.length > 0) {
                var labels = treeUIEnvs.filter(e => sel.indexOf(e) > -1 || locked.indexOf(e) > -1)
                                       .map(e => locked.indexOf(e) > -1 ? e + ' ✓' : e);
                parts.push(s.label + ' (' + labels.join(', ') + ')');
            }
        });
        var el = document.getElementById('spcSelSummary');
        if (el) el.textContent = parts.length ? parts.join(' · ') : 'Ništa nije odabrano';
    }

    function updateEditorButtonVisibility(): void {
        var isEditorMode = ($('#ScriptInputMode input[type=radio]:checked').val() as string) === 'editor';
        if (!isEditorMode) return;
        var hasSchema = !!$('#SchemaList').val();
        var hasClient = GetSelectedNodes().length > 0;
        var canShow = hasSchema && hasClient;
        $('#btnOpenScriptEditor').toggle(canShow);
        if (canShow) {
            $('#spcEditorHint').text('Unesi sadrzaj skripte kroz editor.');
        } else {
            var missing: string[] = [];
            if (!hasSchema) missing.push('shemu');
            if (!hasClient) missing.push('klijenta');
            $('#spcEditorHint').text('Odaberi ' + missing.join(' i ') + ' za prikaz editora.');
        }
    }

    export function InitClientTreeUI(companyList: any, enviromentList: any): void {
        treeUIEnvs = enviromentList.map((e: any) => e.text as string);
        treeUIState = {};

        companyList.forEach(function (c: any) {
            treeUIState[c.value] = { label: c.text, open: false, envs: {}, locked: {}, selected: false };
            treeUIEnvs.forEach(e => treeUIState[c.value].envs[e] = false);
        });

        renderClientGrid();

        // "Svi" button — select/deselect all clients × all envs
        $("#btnSelectAll").on("click", function () {
            var anyUnsel = Object.keys(treeUIState).some(k =>
                treeUIEnvs.some(e => !treeUIState[k].locked[e] && !treeUIState[k].envs[e])
            );
            Object.keys(treeUIState).forEach(k => {
                treeUIEnvs.filter(e => !treeUIState[k].locked[e])
                          .forEach(e => treeUIState[k].envs[e] = anyUnsel);
            });
            renderClientGrid();
        });
    }

    export function HasLockedNodes(): boolean {
        return Object.keys(treeUIState).some(k => Object.keys(treeUIState[k].locked).length > 0);
    }

    export function InitClientTreeUIWithSelection(companyList: any, enviromentList: any, selNodes: any[], lockedNodes?: { [nodeKey: string]: string }): void {
        InitClientTreeUI(companyList, enviromentList);

        if (lockedNodes) {
            Object.keys(lockedNodes).forEach(function (nodeKey: string) {
                var underscore = nodeKey.indexOf('_');
                if (underscore < 0) return;

                var env = nodeKey.substring(0, underscore);
                var cKey = nodeKey.substring(underscore + 1);

                if (!treeUIState[cKey] || !treeUIState[cKey].envs.hasOwnProperty(env)) return;

                treeUIState[cKey].locked[env] = lockedNodes[nodeKey];
                treeUIState[cKey].envs[env] = false;
            });

            renderClientGrid();
        }

        if (!selNodes || selNodes.length === 0) {
            return;
        }

        selNodes.forEach(function (node: any) {
            if (typeof node === 'string') {
                var firstUnderscore = node.indexOf('_');
                if (firstUnderscore < 0) return;

                var env = node.substring(0, firstUnderscore);
                var cKey = node.substring(firstUnderscore + 1);

                if (!treeUIState[cKey]) return;
                if (treeUIState[cKey].envs.hasOwnProperty(env)) {
                    treeUIState[cKey].envs[env] = true;
                }
            } else {
                // Legacy object format: { parentNode: "LABEL_ID", childrenNodes: ["FAT", ...] }
                var parentNode: string = node.parentNode || node.ParentNode || '';
                if (!parentNode) return;
                var underscoreIdx = parentNode.indexOf('_');
                var cKey2 = underscoreIdx >= 0 ? parentNode.substring(underscoreIdx + 1) : parentNode;
                if (!treeUIState[cKey2]) return;
                var envs: string[] = node.childrenNodes || node.ChildrenNodes || [];
                envs.forEach(function (env: string) {
                    if (treeUIState[cKey2].envs.hasOwnProperty(env)) {
                        treeUIState[cKey2].envs[env] = true;
                    }
                });
            }
        });

        renderClientGrid();
    }


    export function InitPillListeners(): void {
        $('#TaskType').on('change', 'input[type="radio"]', function (this: HTMLInputElement) {
            $('#TaskType label').removeClass('active');
            $('label[for="' + this.id + '"]').addClass('active');
        });

        $('#IsParamScript').on('change', 'input[type="radio"]', function (this: HTMLInputElement) {
            $('#IsParamScript label').removeClass('active');
            $('label[for="' + this.id + '"]').addClass('active');
        });

        $('#ProjectList').on('click', '.spc-check-pill', function (e) {
            var $pill = $(this);
            var $checkbox = $pill.find('input[type="checkbox"]');
            if ($(e.target).is('input[type="checkbox"]')) {
                $pill.toggleClass('active', $checkbox.prop('checked'));
            } else {
                var newVal = !$checkbox.prop('checked');
                $checkbox.prop('checked', newVal);
                $pill.toggleClass('active', newVal);
            }
        });

        InitReleaseNoticeToggle();
    }

    export function InitReleaseNoticeToggle(): void {
        $('#IsReleaseNotice').on('change', 'input[type="radio"]', function (this: HTMLInputElement) {
            var isOn = this.value === '1';
            $('#IsReleaseNotice label').removeClass('active');
            $('label[for="' + this.id + '"]').addClass('active');
            $('#spcReleaseNoticeSection').toggle(isOn);
            if (isOn) {
                $('#ReleaseNotice').trigger('focus');
            }
        });

        $('#spcReleaseNoticeSection').toggle($('#IsReleaseNotice input[type=radio]:checked').val() === '1');
    }


    export function InitFileZone(existingScriptId: number = 0): void {
        _droppedFile = null;
        _editorTextContent = '';

        // Start hidden — only show once a file is picked
        $('#btnAiService').hide();

        function getSelectedInputMode(): string {
            return ($('#ScriptInputMode input[type=radio]:checked').val() as string) || 'import';
        }

        function applyFile(file: File): void {
            try {
                var dt = new DataTransfer();
                dt.items.add(file);
                ($('#FileUpload').get(0) as HTMLInputElement).files = dt.files;
            } catch (e) { /* DataTransfer not supported, files set via native input only */ }

            $('#spcFileName').text(file.name);
            var size = file.size >= 1024 * 1024
                ? (file.size / (1024 * 1024)).toFixed(1) + ' MB'
                : (file.size / 1024).toFixed(1) + ' KB';
            $('#spcFileHint').text(size);
            $('#spcFileZone').addClass('spc-file-zone--has-file');
            $('#spcBrowseBtn').text('Promijeni');
            $('#btnAiService').show();
        }

        function clearFile(): void {
            $('#spcFileName').text('Odaberi datoteku');
            $('#spcFileHint').text('SQL, .sql, .txt');
            $('#spcFileZone').removeClass('spc-file-zone--has-file');
            $('#spcBrowseBtn').text('Pretraži');
            $('#btnAiService').hide();
        }

        function createEditorFile(textContent: string, scriptName: string): File {
            var normalizedScriptName = (scriptName || 'NovaSkripta').trim();
            var hasSqlExtension = normalizedScriptName.length >= 4 && normalizedScriptName.substr(normalizedScriptName.length - 4).toUpperCase() === '.SQL';
            var normalizedName = hasSqlExtension ? normalizedScriptName : normalizedScriptName + '.sql';

            try {
                return new File([textContent], normalizedName, { type: 'text/sql' });
            } catch (_err) {
                var fallbackBlob: any = new Blob([textContent], { type: 'text/sql' });
                fallbackBlob.name = normalizedName;
                return fallbackBlob as File;
            }
        }

        function setInputMode(mode: string): void {
            var isEditorMode = mode === 'editor';
            var uploadInput = $('#FileUpload').get(0) as HTMLInputElement;
            var hasUploadFile = !!(uploadInput && uploadInput.files && uploadInput.files.length > 0);

            $('#spcImportSection').toggle(!isEditorMode);
            $('#spcEditorSection').toggle(isEditorMode);
            $('#btnAiService').toggle(!isEditorMode && hasUploadFile);
            if (isEditorMode) { updateEditorButtonVisibility(); }

            $('#ScriptInputMode label').removeClass('active');
            var activeId = isEditorMode ? 'ScriptInputMode_editor' : 'ScriptInputMode_import';
            $('label[for="' + activeId + '"]').addClass('active');
        }

        var skipNextClick = false;

        // Clicking the visible zone div triggers the hidden native input
        $('#spcFileZone').on('click', function () {
            if (skipNextClick) {
                skipNextClick = false;
                return;
            }
            $('#FileUpload').trigger('click');
        });

        // Drag and drop
        $('#spcFileZone').on('dragover dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass('spc-file-zone--drag');
        });

        $('#spcFileZone').on('dragleave dragend', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).removeClass('spc-file-zone--drag');
        });

        $('#spcFileZone').on('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            skipNextClick = true;
            $(this).removeClass('spc-file-zone--drag');
            var dt = e.originalEvent && (e.originalEvent as DragEvent).dataTransfer;
            var file = dt && dt.files && dt.files[0];
            if (file) {
                _droppedFile = file;
                _editorTextContent = '';
                applyFile(file);
                    $('#spcEditorHint').text('Unesi sadrzaj skripte kroz editor.');
            }
        });

        // Show selected filename / size inside the zone
        // Only apply when a file is actually chosen; do nothing on cancel (empty files)
        $('#FileUpload').on('change', function (this: HTMLInputElement) {
            var file = this.files && this.files[0];
            if (file) {
                _droppedFile = null;
                _editorTextContent = '';
                applyFile(file);
                $('#spcEditorHint').text('Unesi sadrzaj skripte kroz editor.');
            }
        });

        $('#ScriptInputMode').on('change', 'input[type="radio"]', function (this: HTMLInputElement) {
            setInputMode(this.value || 'import');
        });

        $('#btnOpenScriptEditor').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            function openEditor(useDraft: boolean) {
                if (!useDraft) {
                    delete (window as any).spcCreateEditorContent;
                }
                (window as any).spcCreateEditorScriptId = existingScriptId;
                (window as any).spcSelectedClientNodes = GetSelectedNodes().map(function(n: any) { return n.parentNode; });
                var title = existingScriptId > 0 ? 'Uredi skriptu - editor' : 'Nova skripta - editor';
                Dialog.OpenDetailsModal(title, '/Script/CreateEditor/' + existingScriptId, 'modal-xxl');
            }

            // A draft only counts if it belongs to this same script (create vs. edit of a
            // specific script are different contexts) — otherwise it's stale from a previous open.
            var sameContext = (window as any).spcCreateEditorScriptId === existingScriptId;
            const draft: string = (sameContext ? ((window as any).spcCreateEditorContent || _editorTextContent || '') : '').trim();

            if (draft) {
                Dialog.ConfirmDialog(
                    'Editor',
                    'Editor već sadrži sadržaj. Želiš nastaviti ili otvoriti izvorni sadržaj?',
                    () => { openEditor(true); },
                    'Nastavi',
                    () => { _editorTextContent = ''; openEditor(false); },
                    existingScriptId > 0 ? 'Izvorni sadržaj' : 'Prazan editor'
                );
            } else {
                openEditor(false);
            }
        });

        $(document).off('spc:create-editor-apply').on('spc:create-editor-apply', function (_event, content) {
            var textContent = (content || '').toString();
            _editorTextContent = textContent;

            var scriptName = ($('#ScriptName').val() as string) || 'NovaSkripta';
            var editorFile = createEditorFile(textContent, scriptName);

            _droppedFile = editorFile;
            applyFile(editorFile);
            $('#spcFileHint').text('Sadrzaj unesen kroz editor');
            $('#spcEditorHint').text('Sadrzaj je spremljen iz editora.');
            // Switch back to Import skripte so user sees the file zone with applied content
            $('#ScriptInputMode_import').prop('checked', true);
            setInputMode('import');

        });

        setInputMode(getSelectedInputMode());

        $('#btnAiService').on('click', function () {
            var uploadFile = $("#FileUpload").get(0) as HTMLInputElement;

            PlsWait.ShowLoader(true);

            if (uploadFile.files.length != 0) {
                var lastDot = uploadFile.files[0].name.lastIndexOf('.');
                var scriptExtension = uploadFile.files[0].name.substring(lastDot + 1);

                if (scriptExtension.toUpperCase() !== "SQL") {
                    Notifications.GetNotification("Skripta mora biti u SQL formatu", "warning");
                    PlsWait.ShowLoader(false);
                    return false;
                }

                Common.AIService.GetAIResponse(false, uploadFile);
            } else {
                PlsWait.ShowLoader(false);
            }
        });
    }


    export function Init(companyList: any, enviromentList: any) {
        IncreaseModal();

        $('#btnAiService').hide();

        $("#SchemaList").select2({
            dropdownParent: $("#ScriptModal"),
            width: "100%",
            placeholder: "Odaberi shemu",
            allowClear: true
        });

        SetScriptName($("#SchemaList :selected").text());

        $("#SchemaList").on("change", function () {
            SetScriptName($("#SchemaList :selected").text());
            updateEditorButtonVisibility();
        });

        $("#btnScriptModal").click(function () {
            $(this).prop("disabled", true);
            SaveScript("create", -1);
            $(this).prop("disabled", false);
        });

        // ── New modal UI ──
        InitClientTreeUI(companyList, enviromentList);
        InitPillListeners();
        InitFileZone();

        $("#DimtTasksList").select2({
            dropdownParent: $("#ScriptModal"),
            ajax: {
                url: "/Script/GetDimtTaskList",
                dataType: 'json',
                delay: 250,
                data: function (params: any) {
                    return { term: params.term || "" };
                },
                processResults: function (data: any) {
                    return {
                        results: $.map(data, function (item: any) {
                            return { id: item.value, text: item.text };
                        })
                    };
                }
            },
            width: "100%"
        });

        $.ajax({
            url: '/Script/GetDimtTaskList',
            type: 'GET'
        }).then(function (data: any) {
            let selectedValue = 5;
            let item = data.find((d: any) => d.value == selectedValue);
            if (item) {
                let option = new Option(item.text, item.value, true, true);
                $("#DimtTasksList").append(option).trigger('change');
            }
        });

        // ChangesetList — load for the currently selected version
        $.ajax({
            url: '/Script/GetChangesetList/' + ($("#versionList").val() || 5),
            type: 'GET',
            contentType: 'application/json',
            success: (data) => {
                $("#ChangesetList").empty();
                var changesets = JSON.parse(data);
                for (var i = 0; i < changesets.length; i++) {
                    $("#ChangesetList").append('<option value="' + changesets[i].Value + '">' + changesets[i].Text + '</option>');
                }
            }
        });

        $("#ScriptModal").on("hidden.bs.modal", (e) => {
            $(e.target).find("*").off();
            PlsWait.ShowStepper(false);
        });

    }

    export function SaveScript(action: string, scriptId: number) {
        var projects: number[] = new Array();
        var scriptData: IScriptData = <IScriptData>{};
        var selectedInputMode = ($('#ScriptInputMode input[type=radio]:checked').val() as string) || 'import';

        if (GetSelectedNodes().length == 0 && !HasLockedNodes()) {
            Notifications.GetNotification("Skriptu treba dodijeliti barem jednom klijentu", "warning");
            return false;
        }

        /*if (!$("#VersionList").val()) {
            Notifications.GetNotification("Nije odabrana verzija baze. Molimo odabrati verziju baze", "warning");
            return false;
        }*/

        if (!$("#SchemaList").val()) {
            Notifications.GetNotification("Nije odabrana schema. Molimo odabrati schemu", "warning");
            return false;
        }

        if ($("#TaskType input[type=radio]:checked").length == 0) {
            Notifications.GetNotification("Molimo odaberite kojem tipu pripada skripta", "warning");
            return false;
        }

        if (!$("#IsParamScript input[type=radio]:checked").val()) {
            Notifications.GetNotification("Molimo odaberite je li skripta parametarska", "warning");
            return false;
        }

        var isReleaseNotice = $("#IsReleaseNotice input[type=radio]:checked").val() === '1';
        var releaseNotice = (($("#ReleaseNotice").val() as string) || '').trim();

        if (isReleaseNotice && !releaseNotice) {
            Notifications.GetNotification("Molimo unesite tekst obavijesti pri puštanju ili odaberite NE", "warning");
            $("#ReleaseNotice").trigger('focus');
            return false;
        }

        if (!$("#DimtTasksList").val()) {
            Notifications.GetNotification("Molimo odaberite DIMT zadatak", "warning");
            return false;
        }

        $('#ProjectList .spc-check-pill.active').each(function () {
            var idStr = $(this).find('input[type="checkbox"]').attr('id') || '';
            var idNum = idStr.replace('proj_', '');
            if (Common.IsNumber(idNum)) {
                projects.push(Number(idNum));
            }
        });

        scriptData.idScript = scriptId;
        scriptData.customers = GetSelectedNodes();
        scriptData.schema = $("#SchemaList :selected").text() as string;
        scriptData.scriptName = $("#ScriptName").val() as string;
        scriptData.description = $("#ScriptDescription").val() as string;
        scriptData.projects = projects;
        scriptData.fileContainer = "skriptecrm";
        scriptData.type = $("#TaskType input[type=radio]:checked").val() as string;
        scriptData.task = $("#DimtTasksList").val() as string;
        scriptData.scriptChangeset = $("#ChangesetList option:selected").text();
        scriptData.scriptVersion = 5;//$("#VersionList").val() as number;
        scriptData.action = action;
        scriptData.isParamScript = $("#IsParamScript input[type=radio]:checked").val() === '1';
        scriptData.idSchema = $("#SchemaList :selected").val() as number;
        scriptData.isReleaseNotice = isReleaseNotice;
        scriptData.releaseNotice = isReleaseNotice ? releaseNotice : null;

        var uploadFile = $("#FileUpload").get(0) as HTMLInputElement;

        if (selectedInputMode === 'editor') {
            if (!_editorTextContent || !_editorTextContent.trim()) {
                Notifications.GetNotification('Odabran je editor. Molimo unesi skriptu u editoru i klikni Primijeni.', 'warning');
                return false;
            }

            try {
                var scriptNameForEditor = (scriptData.scriptName || 'NovaSkripta') as string;
                var editorFile = new File([_editorTextContent], (scriptNameForEditor.length >= 4 && scriptNameForEditor.substr(scriptNameForEditor.length - 4).toUpperCase() === '.SQL') ? scriptNameForEditor : scriptNameForEditor + '.sql', { type: 'text/sql' });
                var editorDt = new DataTransfer();
                editorDt.items.add(editorFile);
                uploadFile.files = editorDt.files;
                _droppedFile = editorFile;
            } catch (_err) {
                Notifications.GetNotification('Greška pri pripremi sadržaja iz editora.', 'danger');
                return false;
            }
        }

        // If the browser reset input.files after a cancelled file-picker (common after drag-drop),
        // re-inject the stored dropped file so the save pipeline can proceed.
        if (uploadFile.files.length === 0 && _droppedFile) {
            try {
                var reinjectDt = new DataTransfer();
                reinjectDt.items.add(_droppedFile);
                uploadFile.files = reinjectDt.files;
            } catch (e) { /* fallthrough */ }
        }

        if (uploadFile.files.length != 0) {
            var lastDot = uploadFile.files[0].name.lastIndexOf('.');
            var scriptExtension = uploadFile.files[0].name.substring(lastDot + 1);

            if (scriptExtension.toUpperCase() !== "SQL") {
                Notifications.GetNotification("Skripta mora biti u SQL formatu", "warning");
                return false;
            }

            let reader = new FileReader();

            reader.onload = (e) => {
                let fileContent = (reader.result as string).toUpperCase();

                if (HandleTruncateCheck(fileContent, uploadFile, scriptData)) return;
                if (HandleAlterObjectCheck(fileContent, uploadFile, scriptData)) return;

                UploadFileToBlobStorage(uploadFile, scriptData);
            };

            reader.onerror = () => {
                Notifications.GetNotification("Greška prilikom čitanja datoteke!", "danger");
            };

            reader.readAsText(uploadFile.files[0]);
        }
        else if (uploadFile.files.length == 0 && action == "update") {
            PlsWait.ShowStepper(true);
            UploadStepper.Validating();
            Save(scriptData);
        }
        else if (uploadFile.files.length == 0 && action == "create") {
            Notifications.GetNotification("Niste odabrali skriptu", "warning");
            return false;
        }
    }

    function HandleTruncateCheck(fileContent: string, uploadFile: HTMLInputElement, scriptData: IScriptData): boolean {
        if (!fileContent.includes("TRUNCATE")) return false;

        let turncateTemplate = `/*
	1. Potrebno zamjeniti ORIGINAL_TABLICA sa nazivom tablice nad kojom se izvodi TRUNCATE
	2. Potrebno zamjeniti ORIGINAL_TABLICA_BKP sa nazivom u koji želite spremiti backup podatke
*/

DECLARE
    v_orig_cnt  NUMBER;
    v_bkp_cnt   NUMBER;
BEGIN
    -- 1. Backup tablice
    EXECUTE IMMEDIATE 'CREATE TABLE ORIGINAL_TABLICA_BKP AS SELECT * FROM ORIGINAL_TABLICA';

    -- 2. Provjera broja zapisa
    SELECT COUNT(*) INTO v_orig_cnt FROM ORIGINAL_TABLICA;
    SELECT COUNT(*) INTO v_bkp_cnt  FROM ORIGINAL_TABLICA_BKP;

    IF v_orig_cnt != v_bkp_cnt THEN
        RAISE_APPLICATION_ERROR(-20001, 'Backup NIJE ispravan! Broj zapisa se ne podudara. ' || 'ORIGINAL=' || v_orig_cnt || ', BACKUP=' || v_bkp_cnt);
    END IF;

    -- 3. TRUNCATE (dozvoljen tek nakon provjere)
    EXECUTE IMMEDIATE 'TRUNCATE TABLE ORIGINAL_TABLICA';
EXCEPTION
    WHEN OTHERS THEN
		INS_ADMIN.LOG_INTERFACE.LOG_TRACE_CLOB('GREŠKA (TRUNCATE ORIGINAL_TABLICA): ' || SQLERRM);
        RAISE;
END;
/`;

        Dialog.ConfirmDialog('UPOZORENJE', `Skripta sadrži TRUNCATE naredbu.
                    <br>
                    <br>
                    OBAVEZNO PRAVILO
                    <br>
                     1. Napraviti backup tablice prije TRUNCATE operacije<br>
                     2. Izvršiti provjeru broja zapisa između originalne i backup tablice<br>
                     3. Prekinuti izvršavanje ako broj zapisa nije identičan
                    <br>
                    <br>
                    Template: <a href="#" id="DownloadTemplate">Truncate template</a>`, () => {
            UploadFileToBlobStorage(uploadFile, scriptData);
        }, 'Nastavi');

        $("#DownloadTemplate").off("click").on("click", (e) => {
            e.preventDefault();
            DownloadTextFile(turncateTemplate, "Truncate template.sql");
        });

        return true;
    }

    function HandleAlterObjectCheck(fileContent: string, uploadFile: HTMLInputElement, scriptData: IScriptData): boolean {
        // If the script is a PL/SQL block (starts with BEGIN, CREATE or DECLARE — optionally
        // preceded by a SET DEFINE line), skip the check
        var trimmedContent = fileContent.replace(/^\s+/, '');
        if (trimmedContent.indexOf('SET DEFINE') === 0) {
            var newlineIdx = trimmedContent.indexOf('\n');
            trimmedContent = newlineIdx !== -1 ? trimmedContent.substring(newlineIdx + 1).replace(/^\s+/, '') : '';
        }
        if (trimmedContent.indexOf('BEGIN') === 0 ||
            trimmedContent.indexOf('CREATE') === 0 ||
            trimmedContent.indexOf('DECLARE') === 0) {
            return false;
        }

        // Extract all object names that appear after ALTER TABLE
        // Match full identifier (schema.table or just table) — same approach as ScriptParser.cs
        const alterTableRegex = /ALTER\s+TABLE\s+([\w.]+)/g;
        let match: RegExpExecArray | null;
        const alteredObjects: string[] = [];

        while ((match = alterTableRegex.exec(fileContent)) !== null) {
            var fullName = match[1];
            // Strip schema prefix if present (e.g. INS_ACRM.TSK_TASKS → TSK_TASKS)
            var dotIndex = fullName.indexOf('.');
            var objectName = dotIndex !== -1 ? fullName.substring(dotIndex + 1) : fullName;
            if (alteredObjects.indexOf(objectName) === -1) {
                alteredObjects.push(objectName);
            }
        }

        if (alteredObjects.length === 0) return false;

        var rawLookup = (window as any).arhObjectLookup;
        var arhObjectLookup: { OriginalObjectName: string; ArhObjectName: string }[] =
            (rawLookup != null) ? rawLookup : [];

        var missingArhObjects: string[] = [];
        for (var i = 0; i < alteredObjects.length; i++) {
            var objectName = alteredObjects[i];
            var entry: { OriginalObjectName: string; ArhObjectName: string } = null;
            for (var j = 0; j < arhObjectLookup.length; j++) {
                if (arhObjectLookup[j].OriginalObjectName.toUpperCase() === objectName) {
                    entry = arhObjectLookup[j];
                    break;
                }
            }
            if (entry !== null && fileContent.indexOf(entry.ArhObjectName.toUpperCase()) === -1) {
                missingArhObjects.push(entry.ArhObjectName);
            }
        }

        if (missingArhObjects.length === 0) return false;

        var missingList = '';
        for (var k = 0; k < missingArhObjects.length; k++) {
            missingList += '<br> - ' + missingArhObjects[k];
        }

        Dialog.ConfirmDialog('UPOZORENJE', 'Skripta sadrži ALTER TABLE naredbu i nalazi se u popisu tablica za koje je potrebno osigurati odgovarajuće ARH objekte:'
                    + missingList
                    + '<br><br>Jeste li sigurni da želite nastaviti?', () => {
            UploadFileToBlobStorage(uploadFile, scriptData);
        }, 'Nastavi');

        return true;
    }

    function DownloadTextFile(text: string, fileName: string, mimeType: string = "text/sql") {
        const blob = new Blob([text], { type: mimeType });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.style.display = "none";

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    function UploadFileToBlobStorage(uploadFile: HTMLInputElement, scriptData: IScriptData) {
        let customerList: string[] = [];

        scriptData.customers.forEach((customer) => {
            customerList.push(customer.parentNode.split("_")[0] as string);
        });

        var file = Common.SetFileData(uploadFile, scriptData.scriptName);
        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = `/Script/UploadFile/${scriptData.scriptVersion}/${scriptData.schema}/${scriptData.action}/${customerList}/${scriptData.idScript}`;
        ajaxParams.type = 'POST';
        ajaxParams.contentType = false;
        ajaxParams.processData = false;
        ajaxParams.data = file;

        PlsWait.ShowStepper(true);
        UploadStepper.Uploading();

        ajaxParams.beforeSend = () => {
            UploadStepper.Validating();
        };

        ajaxParams.success = (result) => {
            if (result.indexOf("Greška") == -1) {
                scriptData.scriptName = result;
                Save(scriptData);
            } else {
                UploadStepper.Error(result.substring(7));
            }
        };

        ajaxParams.error = (jqXHR, textStatus, errorThrown) => {
            let message = "Unknown error";

            if (jqXHR.responseText) {
                try {
                    let json = JSON.parse(jqXHR.responseText);
                    if (json.message) {
                        message = json.message;
                    } else {
                        message = jqXHR.responseText;
                    }
                } catch (e) {
                    message = jqXHR.responseText;
                }
            } else if (errorThrown) {
                message = errorThrown;
            } else if (textStatus) {
                message = textStatus;
            }

            console.log("Greška AJAX poziva:", message);
            UploadStepper.Error(message);
        };

        $.ajax(ajaxParams);
    }

    function Save(scriptData: IScriptData) {
        UploadStepper.Saving();

        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/Script/Create';
        ajaxParams.type = 'POST';
        ajaxParams.dataType = 'json';
        ajaxParams.contentType = 'application/json';
        ajaxParams.data = JSON.stringify(scriptData);
        ajaxParams.success = (result) => {
            UploadStepper.Done(scriptData.scriptName);
            // Clear editor session so the next open starts with a fresh empty editor
            _editorTextContent = '';
            _droppedFile = null;
            delete (window as any).spcCreateEditorContent;
            (window as any).spcCreateEditorScriptId = undefined;
            (window as any).spcSelectedClientNodes = [];
        };
        ajaxParams.error = (err) => {
            var msg = (err.responseJSON && err.responseJSON.message) ? err.responseJSON.message : err.statusText;
            UploadStepper.Error(msg);
            Notifications.GetNotification(msg, "danger");
        };

        $.ajax(ajaxParams);
    }

    function SetScriptName(selOption) {
        var newName = $("#scriptNameHidd").val() + "_" + selOption;
        $("#ScriptName").val(newName);
    }

    function GetSelectedNodes() {
        arrayOfSelectedNodes = new Array<ISelectedNodes>();

        Object.keys(treeUIState).forEach(function (key: string) {
            var s = treeUIState[key];
            var selectedEnvs = treeUIEnvs.filter(e => s.envs[e]);

            if (selectedEnvs.length === 0) return;

            var selectedNodes: ISelectedNodes = <ISelectedNodes>{};

            selectedNodes.parentNode = key;
            selectedNodes.childrenNodes = selectedEnvs;

            arrayOfSelectedNodes.push(selectedNodes);
        });

        return arrayOfSelectedNodes;
    };
}

module ScriptsPerCustomer.Edit {
    export function Init(companyList: any, enviromentList: any, selNodes: any, selectedTask: string, lockedNodes?: { [nodeKey: string]: string }) {
        IncreaseModal();

        var scriptId: number = parseInt(($('#scriptId').val() || '0').toString(), 10) || 0;

        $('#btnAiService').hide();

        $("#SchemaList").select2({
            dropdownParent: $("#ScriptModal"),
            width: "100%",
            placeholder: "Odaberi shemu",
            allowClear: true
        });

        $("#SchemaList").on("change", function () {
            var scriptName: string = $("#ScriptName").val() as string;
            scriptName = scriptName.split('INS_')[0];
            $("#ScriptName").val(scriptName + $("#SchemaList :selected").text());
        });

        $("#btnScriptModal").click(function () {
            var scriptId: number = parseInt($("#scriptId").val().toString());
            Create.SaveScript("update", scriptId);
        });

        // Initialise new tree UI; pre-select nodes passed from server
        Create.InitClientTreeUIWithSelection(companyList, enviromentList, selNodes, lockedNodes);
        Create.InitPillListeners();
        Create.InitFileZone(scriptId);

        $("#DimtTasksList").select2({
            dropdownParent: $("#ScriptModal"),
            ajax: {
                url: "/Script/GetDimtTaskList",
                dataType: 'json',
                delay: 250,
                data: function (params: any) {
                    return { term: params.term || "" };
                },
                processResults: function (data: any) {
                    return {
                        results: $.map(data, function (item: any) {
                            return { id: item.value, text: item.text };
                        })
                    };
                }
            },
            width: "100%"
        });

        if (selectedTask) {
            $.ajax({
                url: '/Script/GetDimtTaskList',
                type: 'GET',
                data: { term: selectedTask }
            }).then(function (data: any) {
                var matched = data.find((item: any) =>
                    item.value == selectedTask ||
                    item.value.indexOf(selectedTask + '_') === 0 ||
                    item.text.includes(selectedTask)
                );
                if (matched) {
                    var option = new Option(matched.text, matched.value, true, true);
                    $("#DimtTasksList").append(option).trigger('change');
                }
            });
        }

        $("#ScriptModal").on("hidden.bs.modal", (e) => {
            $(e.target).find("*").off();
        });
    }
}

module ScriptsPerCustomer.Delete {
    export function Init() {
        $("#btnScriptModal").click(function () {
            PlsWait.ShowLoader(true);
            var ajaxParams: JQueryAjaxSettings = {};
            ajaxParams.url = "/Script/Delete/" + $("#ScriptId").val();
            ajaxParams.type = 'POST';
            ajaxParams.contentType = 'application/json';
            ajaxParams.success = (result) => {
                $("#ScriptModal .close").click();
                PlsWait.ShowLoader(false);
                Notifications.GetNotificationWithProgressBar("Delete file", "success");
                window.location.href = '/Script/List/' + $("#companyList").val() + '/' + $("#versionList").val();
            };
            ajaxParams.error = (err) => {
                PlsWait.ShowLoader(false);
                Notifications.GetNotification(err.statusText, "danger");
            };

            $.ajax(ajaxParams);
        });
    }
}

module ScriptsPerCustomer.Details {
    export function Init() {
        $(".details-download-script").on("click", function () {
            var idVersion: string = $(this).data("id-version").toString();
            var scriptName: string = $(this).data("file-name").toString();
            ScriptsPerCustomer.DownloadScript(idVersion, scriptName);
        });

        $(".details-ai-script").on("click", function () {
            var idVersion: string = $(this).data("id-version").toString();
            var scriptName: string = $(this).data("file-name").toString();
            Common.AIService.GetAIResponse(true, '', idVersion, scriptName);
        });
    }
}

module ReleasedScripts {
    var statusTabInited = false;
    var rnTabInited = false;
    var calendarTabInited = false;

    export function Init(dates: any): void {
        PlsWait.ShowLoader(false);
        var dateFrom = dates.split("$")[0];
        var dateTo = dates.split("$")[1];

        $('#dateFrom').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateFrom').datepicker('update', Common.FormatDate(dateFrom, 'eu'));

        $('#dateTo').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: $('#dateFrom').val().toString(),
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateTo').datepicker('update', Common.FormatDate(dateTo, 'eu'));

        Common.FilterBar.Init(function () { applyFilters(); }, {
            applyBtnId: 'setDates',
            watchSelects: true,
            hasDates: true,
            hasEnvironment: true,
            onEnvironmentChange: function () {
                if ($('#tab-status').hasClass('active') && statusTabInited) {
                    reloadStatusTab();
                }
            }
        });

        initTables();

        // Show/hide Okolina filter based on active tab
        function syncEnvironmentFilter(): void {
            const isStatusTab = $('#tab-status').hasClass('active');
            $('#environmentFilterItem').toggle(isStatusTab);
        }

        syncEnvironmentFilter();

        $('#tab-pustene').on('shown.bs.tab', function () {
            syncEnvironmentFilter();
            if ($.fn.dataTable.isDataTable('#scriptDataTable')) {
                $('#scriptDataTable').DataTable().columns.adjust();
            }
            if ($.fn.dataTable.isDataTable('#confirmedTable')) {
                $('#confirmedTable').DataTable().columns.adjust();
            }
        });

        // Kalendar tab: lazy-load on first show
        calendarTabInited = false;
        $('#tab-kalendar').on('shown.bs.tab', function () {
            syncEnvironmentFilter();
            if (!calendarTabInited) {
                calendarTabInited = true;
                loadCalendar();
            } else {
                loadCalendar();
            }
        });

        // Status tab: init on first show
        statusTabInited = false;
        $('#tab-status').on('shown.bs.tab', function () {
            syncEnvironmentFilter();
            if (!statusTabInited) {
                statusTabInited = true;
                // Wait for Bootstrap fade to fully complete before DataTables
                // measures scroll dimensions (prevents _fnScrollDraw crash)
                setTimeout(function () { initStatusTab(); }, 200);
            } else {
                $('#statusMetaTable').DataTable().columns.adjust();
            }
        });

        // Third tab: Release Notes
        $('#tab-release-notes').on('shown.bs.tab', function () {
            $('#environmentFilterItem').hide();
            if (!rnTabInited) {
                rnTabInited = true;
                setTimeout(function () { ReleaseNotes.Init(); }, 200);
            } else {
                ReleaseNotes.Reload();
            }
        });

        $('#scriptDataTable').on('click', '.released-script-details', function () {
            const scriptId = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', `/Script/Details/${scriptId}`);
        });

        // Potvrdi button click handler
        $(document).on('click', '.confirm-env-btn', function () {
            const env = $(this).data('env');
            const id = $(this).data('id');
            const fileName = $(this).data('file-name');
            Dialog.ConfirmDialog(
                'Potvrda puštanja',
                `Jeste li sigurni da želite potvrditi puštanje (<strong>${env}</strong>):<br><strong>${fileName}</strong>`,
                function () {
                    $.ajax({
                        url: '/Script/ConfirmRelease',
                        type: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify({ id: id, notes: '' }),
                        success: function () {
                            loadPendingReleases();
                            loadReleaseConfirmStats();
                            if (($.fn.DataTable as any).isDataTable('#confirmedTable')) {
                                $('#confirmedTable').DataTable().ajax.url(Common.FilterBar.BuildUrl('/Script/ReleaseConfirmationListData') + '&confirmed=true').load();
                            }
                        },
                        error: function () {
                            Dialog.ConfirmDialog('Greška', 'Greška pri potvrđivanju.', function () { }, 'OK');
                        }
                    });
                }
            );
        });
    }

    function getEnvironment(): string {
        var val = $("#environmentList").val();
        return val ? val.toString() : '';
    }

    function initTables(): void {
        loadReleaseConfirmStats();
        loadPendingReleases();

        // scriptDataTable — Popis puštanja
        var scriptColDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 7,
                width: '40px',
                className: 'spc-td-actions',
                orderable: false,
                render: function (data) {
                    return `<div class='spc-actions-wrap'><a class='spc-table-action released-script-details' data-id-script='${data}' title='Detalji'><i class='fas fa-info-circle spc-action-icon spc-action-icon--info'></i></a></div>`;
                }
            }
        ];

        Common.DataTableCustom.Init(
            "scriptDataTable",
            {
                pageLength: 25,
                order: [[0, "desc"]],
                scrollY: '55vh',
                columns: [
                    { data: 0, title: 'Naziv' },
                    { data: 1, title: 'Datum' },
                    { data: 2, title: 'Fat' },
                    { data: 3, title: 'Uat' },
                    { data: 4, title: 'Prod' },
                    { data: 5, title: 'Preskočeno' },
                    { data: 6, title: 'Param' },
                    { data: 7, title: 'Detalji' }
                ]
            },
            scriptColDef,
            Common.FilterBar.BuildUrl('/Script/ReleasedScriptsListData')
        );

        // confirmedTable — Potvrđeno
        var confirmedColDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 0,
                className: 'text-left'
            },
            { targets: [7, 8], visible: false },
            {
                targets: 6,
                width: '60px',
                className: 'spc-td-actions',
                orderable: false,
                render: function (_data: any, _type: any, row: any[]) {
                    const filePath = row[7];
                    const fileName = row[8];
                    if (!filePath || !fileName) {
                        return `<div class='spc-actions-wrap'>`
                             + `<i class='fas fa-cloud-download-alt spc-action-icon spc-action-icon--disabled' title='Datoteka nije dostupna za preuzimanje' style='opacity:0.35; cursor:default;'></i>`
                             + `</div>`;
                    }
                    return `<div class='spc-actions-wrap'>`
                         + `<a class='spc-table-action rc-download-btn' data-file-path='${filePath}' data-file-name='${fileName}' title='Preuzmi'><i class='fas fa-cloud-download-alt spc-action-icon spc-action-icon--download'></i></a>`
                         + `</div>`;
                }
            }
        ];

        Common.DataTableCustom.Init(
            "confirmedTable",
            {
                pageLength: 5,
                order: [[4, "desc"]],
                scrollY: '20vh',
                columns: [
                    { data: 0, title: 'Naziv datoteke' },
                    { data: 1, title: 'Okolina' },
                    { data: 2, title: 'Generirano' },
                    { data: 3, title: 'Generirao' },
                    { data: 4, title: 'Potvrđeno' },
                    { data: 5, title: 'Potvrdio' },
                    { data: 6, title: 'Akcije' },
                    { data: 7, title: '' },
                    { data: 8, title: '' }
                ]
            },
            confirmedColDef,
            Common.FilterBar.BuildUrl('/Script/ReleaseConfirmationListData') + '&confirmed=true'
        );

        $('#confirmedTable')
            .off('click.rcDownload').on('click.rcDownload', '.rc-download-btn', function () {
                const filePath = $(this).data('file-path') as string;
                const fileName = $(this).data('file-name') as string;
                if (!filePath || !fileName) return;
                window.location.href = '/Script/DownloadReleasedFile?filePath=' + encodeURIComponent(filePath)
                    + '&fileName=' + encodeURIComponent(fileName);
            });
    }

    function initStatusTab(): void {
        Common.DataTableCustom.Destroy('statusMetaTable');

        // Hard-reset thead after destroy so DataTables never counts stale injected <th> elements.
        $('#statusMetaTable thead tr').html(
            '<th>Naziv skripte</th>' +
            '<th>Datum puštanja</th>' +
            '<th>Tip</th>' +
            '<th>Schema</th>' +
            '<th>Naziv objekta</th>' +
            '<th>Linija</th>' +
            '<th>Detalji</th>' +
            '<th>Timeline</th>'
        );

        $.ajax({
            url: Common.FilterBar.BuildUrl('/Script/ReleasedMetaDataStats', getEnvironment()),
            type: 'GET',
            success: function (data: any) {
                $('#statCntObjects').text(data.cntObjects);
                $('#statCntScripts').text(data.cntScripts);
                $('#statMostFreq').text(data.mostFreq);
            }
        });

        var metaColDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 5,
                className: 'text-wrap',
                createdCell: function (td) {
                    $(td).css({ 'white-space': 'normal', 'word-break': 'break-all', 'overflow-wrap': 'anywhere' });
                }
            },
            {
                targets: 6,
                orderable: false,
                width: '40px',
                className: 'spc-td-actions',
                render: function (data) {
                    return `<div class='spc-actions-wrap'><a class='spc-table-action status-meta-details' data-id-script='${data}' title='Detalji'><i class='fas fa-info-circle spc-action-icon spc-action-icon--info'></i></a></div>`;
                }
            },
            {
                targets: 7,
                orderable: false,
                width: '40px',
                className: 'spc-td-actions',
                render: function (data: string) {
                    if (!data) return '';
                    try {
                        const info = JSON.parse(data);
                        if (!info.metaName) return '';
                        const encoded = encodeURIComponent(JSON.stringify(info));
                        return `<div class='spc-actions-wrap'><a class='spc-table-action status-meta-timeline' data-timeline='${encoded}' title='Timeline'><i class='fas fa-history spc-action-icon' style='color:#7C3AED;'></i></a></div>`;
                    } catch (e) { return ''; }
                }
            }
        ];

        Common.DataTableCustom.Init(
            'statusMetaTable',
            {
                pageLength: 25,
                scrollY: '45vh',
                order: [[1, 'desc']],
                columns: [
                    { data: 0, title: 'Naziv skripte' },
                    { data: 1, title: 'Datum puštanja' },
                    { data: 2, title: 'Tip' },
                    { data: 3, title: 'Schema' },
                    { data: 4, title: 'Naziv objekta' },
                    { data: 5, title: 'Linija' },
                    { data: 6, title: 'Detalji' },
                    { data: 7, title: 'Timeline' }
                ]
            },
            metaColDef,
            Common.FilterBar.BuildUrl('/Script/ReleasedMetaDataListData', getEnvironment())
        );

        $('#statusMetaTable').off('click.statusMeta').on('click.statusMeta', '.status-meta-details', function () {
            const scriptId = $(this).data('id-script');
            Dialog.OpenDetailsModal('Detalji skripte', '/Script/Details/' + scriptId);
        }).on('click.statusMeta', '.status-meta-diff', function () {
            const idMetaData = $(this).data('id-meta-data');
            Dialog.OpenModal('<i class="fas fa-exchange-alt" style="margin-right:6px;color:#378ADD;"></i>Razlike skripte', '', `/ScriptMetaData/DiffDetail/${idMetaData}`);
        }).on('click.statusMeta', '.status-meta-timeline', function () {
            const raw = decodeURIComponent($(this).data('timeline'));
            const info = JSON.parse(raw);
            if (typeof (window as any).openTimeline === 'function') {
                const openedScriptId = parseInt(info.idScript, 10);
                (window as any).openTimeline(info.metaName, info.metaType, info.metaUser, isNaN(openedScriptId) ? null : openedScriptId);
                $('#TimelineModal').modal('show');
            }
        });
    }

    function loadPendingReleases(): void {
        const idCompany = $('#companyList').val();
        $.ajax({
            url: `/Script/PendingReleasesByEnvironment?idCompany=${idCompany}`,
            type: 'GET',
            success: function (data: { FAT: any; UAT: any; PROD: any }) {
                const envs: Array<'FAT' | 'UAT' | 'PROD'> = ['FAT', 'UAT', 'PROD'];
                let anyPending = false;

                envs.forEach(function (env) {
                    const item = data[env];
                    const $row  = $(`#rcPendingRow-${env}`);
                    const $file = $(`#rcFile-${env}`);
                    const $date = $(`#rcDate-${env}`);
                    const $btn  = $(`#rcBtn-${env}`);
                    const $ok   = $(`#rcOk-${env}`);
                    const $last = $(`#rcLast-${env}`);

                    if (item && item.pending) {
                        anyPending = true;
                        $row.show().addClass('rc-pending-row--pending');
                        $file.html(`${item.fileName} <span style="color:#888;font-size:11px;margin-left:8px;">Generirano: ${item.generatedDate}</span>`).show();
                        $date.hide();
                        $last.hide();
                        $btn.data('id', item.id).data('file-name', item.fileName).data('env', env).show();
                        $ok.hide();
                    } else {
                        $row.show().removeClass('rc-pending-row--pending');
                        $btn.hide();
                        if (item && item.lastConfirmed) {
                            $file.html(`${item.lastConfirmed.fileName} <span style="color:#888;font-size:11px;margin-left:8px;">Generirano: ${item.lastConfirmed.generatedDate}</span>`).show();
                            $date.hide();
                            $last.hide();
                            $ok.hide();
                        } else {
                            $file.hide();
                            $date.hide();
                            $last.hide();
                            $ok.hide();
                        }
                    }

                    // Automatska potvrda iz Script_execution_log
                    const $autoLog = $(`#rcAutoLog-${env}`);
                    if (item && item.lastConfirmed) {
                        // Ručno potvrđeno u Release_Confirmation - zeleno
                        $autoLog.html(`<span style="color:#12b76a;">Puštanje potvrđeno: <strong>${item.lastConfirmed.confirmedDate}</strong> <i class="fas fa-check-circle"></i></span>`).show();
                    } else if (item && item.autoExecLog && item.autoExecLog.hasLog) {
                        // Log postoji ali još nije ručno potvrđeno - žuto
                        $autoLog.html(`<i class="fas fa-exclamation-triangle" style="margin-right:4px;color:#F79009;"></i><span style="color:#F79009;">Postoji automatska potvrda: <strong>${item.autoExecLog.executionDate}</strong></span>`).show();
                    } else if (item && item.pending) {
                        // Nema loga - narančasto upozorenje
                        $autoLog.html(`<i class="fas fa-exclamation-triangle" style="margin-right:4px;color:#FD970F;"></i><span style="color:#FD970F;">Nema automatske potvrde</span>`).show();
                    } else {
                        $autoLog.hide();
                    }
                });

                $('#rcPendingEmpty').toggle(!anyPending && false); // rows are always shown now
            }
        });
    }

    function loadReleaseConfirmStats(): void {
        $.ajax({
            url: Common.FilterBar.BuildUrl('/Script/ReleaseConfirmationStats'),
            type: 'GET',
            success: function (data: { pending: number; confirmed: number; total: number }) {
                $('#rcStatTotal').text(data.total);
                $('#rcStatPending').text(data.pending);
                $('#rcStatConfirmed').text(data.confirmed);
            }
        });
    }

    function reloadStatusTab(): void {
        $.ajax({
            url: Common.FilterBar.BuildUrl('/Script/ReleasedMetaDataStats', getEnvironment()),
            type: 'GET',
            success: function (data: any) {
                $('#statCntObjects').text(data.cntObjects);
                $('#statCntScripts').text(data.cntScripts);
                $('#statMostFreq').text(data.mostFreq);
            }
        });
        if ($.fn.dataTable.isDataTable('#statusMetaTable')) {
            $('#statusMetaTable').DataTable().ajax.url(Common.FilterBar.BuildUrl('/Script/ReleasedMetaDataListData', getEnvironment())).load();
        }
    }

    function loadCalendar(): void {
        const $loader = $('#releasedCalendarLoader');
        const $grid   = $('#releasedCalendarGrid');
        const $legend = $('#releasedCalendarLegend');
        const selectedEnvs: { fat: boolean; uat: boolean; prod: boolean } = { fat: true, uat: true, prod: true };

        const pad2 = function (n: number): string { return n < 10 ? '0' + n : '' + n; };

        $loader.show();
        $grid.hide().empty();
        $legend.hide();

        $.ajax({
            url: Common.FilterBar.BuildUrl('/Script/ReleasedScriptsCalendarData'),
            type: 'GET',
            success: function (data: Array<{ date: string; fat: number; uat: number; prod: number }>) {
                $loader.hide();

                if (!data || data.length === 0) {
                    $grid.html('<span class="rs-calendar-empty">Nema puštanja u odabranom periodu.</span>').show();
                    return;
                }

                // Build a map date -> {fat, uat, prod}
                const dayMap: { [key: string]: { fat: number; uat: number; prod: number } } = {};
                data.forEach(function (item) {
                    dayMap[item.date] = { fat: item.fat || 0, uat: item.uat || 0, prod: item.prod || 0 };
                });

                // Determine date range from filter bar
                const rawFrom = $('#dateFrom').val().toString();
                const rawTo   = $('#dateTo').val().toString();
                const parseEuDate = function (s: string): Date {
                    const parts = s.split('.');
                    return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                };
                const fromDate = parseEuDate(rawFrom);
                const toDate   = parseEuDate(rawTo);

                // Group days by month
                const months: { [key: string]: Date[] } = {};
                const cur = new Date(fromDate);
                cur.setDate(1);
                while (cur <= toDate) {
                    const key = cur.getFullYear() + '-' + pad2(cur.getMonth() + 1);
                    months[key] = [];
                    cur.setMonth(cur.getMonth() + 1);
                }
                const d = new Date(fromDate);
                while (d <= toDate) {
                    const mKey = d.getFullYear() + '-' + pad2(d.getMonth() + 1);
                    if (months[mKey]) months[mKey].push(new Date(d));
                    d.setDate(d.getDate() + 1);
                }

                const dayNames   = ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'];
                const monthNames = ['Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj',
                                    'Srpanj', 'Kolovoz', 'Rujan', 'Listopad', 'Studeni', 'Prosinac'];

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                let html = '';
                Object.keys(months).forEach(function (mKey) {
                    const days = months[mKey];
                    if (days.length === 0) return;

                    const year  = parseInt(mKey.split('-')[0]);
                    const month = parseInt(mKey.split('-')[1]) - 1;
                    const mName = monthNames[month] + ' ' + year;

                    html += '<div class="rs-cal-month">';
                    html += '<div class="rs-cal-month-title">' + mName + '</div>';
                    html += '<div class="rs-cal-day-headers">';
                    dayNames.forEach(function (dn) { html += '<span>' + dn + '</span>'; });
                    html += '</div>';
                    html += '<div class="rs-cal-days">';

                    // Leading empty cells for day-of-week offset
                    const firstDay = new Date(year, month, 1).getDay();
                    for (let i = 0; i < firstDay; i++) {
                        html += '<span class="rs-cal-day rs-cal-empty"></span>';
                    }

                    days.forEach(function (day) {
                        const isoKey = day.getFullYear() + '-' + pad2(day.getMonth() + 1) + '-' + pad2(day.getDate());
                        const counts = dayMap[isoKey];
                        const isToday = (day.getTime() === today.getTime());
                        const hasData = counts && (counts.fat + counts.uat + counts.prod) > 0;

                        let tooltip = pad2(day.getDate()) + '.' + pad2(day.getMonth() + 1) + '.' + day.getFullYear();
                        if (hasData) {
                            tooltip += ' — ';
                            const parts: string[] = [];
                            if (counts.fat  > 0) parts.push('FAT: '  + counts.fat);
                            if (counts.uat  > 0) parts.push('UAT: '  + counts.uat);
                            if (counts.prod > 0) parts.push('PROD: ' + counts.prod);
                            tooltip += parts.join(' | ');
                        }

                        let cls = 'rs-cal-day';
                        if (isToday) cls += ' rs-cal-today';
                        if (!hasData) cls += ' rs-cal-level-0';

                        const label = pad2(day.getDate()) + '.' + pad2(day.getMonth() + 1) + '.' + day.getFullYear();
                        const dataAttrs = hasData
                            ? ' data-date="' + isoKey + '" data-label="' + label + '" data-fat="' + counts.fat + '" data-uat="' + counts.uat + '" data-prod="' + counts.prod + '" style="cursor:pointer;"'
                            : '';

                        html += '<span class="' + cls + '" title="' + tooltip + '"' + dataAttrs + '>';
                        html += '<span class="rs-cal-day-num">' + day.getDate() + '</span>';
                        if (hasData) {
                            html += '<span class="rs-cal-env-pills">';
                            if (counts.fat  > 0) html += '<span class="rs-env-pill rs-env-fat">'  + counts.fat  + '</span>';
                            if (counts.uat  > 0) html += '<span class="rs-env-pill rs-env-uat">'  + counts.uat  + '</span>';
                            if (counts.prod > 0) html += '<span class="rs-env-pill rs-env-prod">' + counts.prod + '</span>';
                            html += '</span>';
                        }
                        html += '</span>';
                    });

                    html += '</div></div>';
                });

                $grid.html(html).show();
                $legend.html(''
                    + '<button type="button" class="rs-legend-item is-active" data-env="fat">'
                    + '<span class="rs-env-legend-dot rs-env-fat"></span><span class="rs-legend-label">FAT</span>'
                    + '</button>'
                    + '<button type="button" class="rs-legend-item is-active" data-env="uat">'
                    + '<span class="rs-env-legend-dot rs-env-uat"></span><span class="rs-legend-label">UAT</span>'
                    + '</button>'
                    + '<button type="button" class="rs-legend-item is-active" data-env="prod">'
                    + '<span class="rs-env-legend-dot rs-env-prod"></span><span class="rs-legend-label">PROD</span>'
                    + '</button>');
                $legend.show();

                const applyLegendFilter = function (): void {
                    selectedEnvs.fat = $legend.find('.rs-legend-item[data-env="fat"]').hasClass('is-active');
                    selectedEnvs.uat = $legend.find('.rs-legend-item[data-env="uat"]').hasClass('is-active');
                    selectedEnvs.prod = $legend.find('.rs-legend-item[data-env="prod"]').hasClass('is-active');

                    $grid.find('.rs-cal-day:not(.rs-cal-empty):not(.rs-cal-level-0)').each(function () {
                        const $day = $(this);
                        const fat = parseInt(($day.data('fat') || 0).toString(), 10) || 0;
                        const uat = parseInt(($day.data('uat') || 0).toString(), 10) || 0;
                        const prod = parseInt(($day.data('prod') || 0).toString(), 10) || 0;

                        const isVisible = (selectedEnvs.fat && fat > 0)
                            || (selectedEnvs.uat && uat > 0)
                            || (selectedEnvs.prod && prod > 0);

                        $day.toggleClass('rs-cal-day-filtered-out', !isVisible);
                        $day.find('.rs-env-pill.rs-env-fat').toggle(selectedEnvs.fat);
                        $day.find('.rs-env-pill.rs-env-uat').toggle(selectedEnvs.uat);
                        $day.find('.rs-env-pill.rs-env-prod').toggle(selectedEnvs.prod);
                    });
                };

                $legend.off('click.rsLegend').on('click.rsLegend', '.rs-legend-item', function () {
                    $(this).toggleClass('is-active');
                    applyLegendFilter();
                });

                applyLegendFilter();

                // Click-to-zoom: show detail in ScriptDetailsModal for days that have releases
                $grid.find('.rs-cal-day:not(.rs-cal-empty):not(.rs-cal-level-0)').on('click', function () {
                    if ($(this).hasClass('rs-cal-day-filtered-out')) return;

                    const isoDate: string = $(this).data('date');
                    const label: string   = $(this).data('label');
                    if (!isoDate) return;

                    Common.DataTableCustom.Destroy('calDayTable');
                    $('#ScriptDetailsModalTitleText').text('Puštanja — ' + label);
                    $('#ScriptDetailsModalTitleTag').hide();
                    $('#btnScriptDetailsModal').hide();
                    $('#ScriptDetailsModalBody').html(
                        Common.Spinner.html()
                    );
                    ($('#ScriptDetailsModal') as any).modal({ backdrop: 'static', keyboard: false, show: true }).modal('show');

                    $.ajax({
                        url: Common.FilterBar.BuildUrl('/Script/ReleasedScriptsForDate') + '&date=' + encodeURIComponent(isoDate),
                        type: 'GET',
                        success: function (scripts: Array<any>) {
                            if (!scripts || scripts.length === 0) {
                                $('#ScriptDetailsModalBody').html('<p class="text-muted px-3 py-2">Nema skripti za ovaj datum.</p>');
                                return;
                            }

                            // ── Build Summary Section ────────────────────────────────────────
                            let totalScripts = scripts.length;
                            let allMetaData: any[] = [];
                            let metaTypeCount: { [key: string]: number } = {};
                            let objectNames = new Set<string>();
                            let fatCount = 0, uatCount = 0, prodCount = 0;

                            scripts.forEach(function (s) {
                                if (s.fat)  fatCount++;
                                if (s.uat)  uatCount++;
                                if (s.prod) prodCount++;
                                if (s.metaData && Array.isArray(s.metaData)) {
                                    s.metaData.forEach(function (meta: any) {
                                        allMetaData.push(meta);
                                        metaTypeCount[meta.metaType] = (metaTypeCount[meta.metaType] || 0) + 1;
                                        if (meta.metaName) {
                                            objectNames.add(meta.metaName);
                                        }
                                    });
                                }
                            });

                            let summaryHtml = '<div class="meta-stats meta-stats--sm">'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#EFF6FF;color:#378ADD;"><i class="fas fa-file-alt"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">Ukupno skripti</span><span class="meta-stat-value">' + totalScripts + '</span><span class="meta-stat-sub">Br. skripti za ovaj dan</span></div>'
                                + '</div>'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#ecfdf3;color:#12b76a;"><i class="fas fa-database"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">Objekata</span><span class="meta-stat-value">' + objectNames.size + '</span><span class="meta-stat-sub">Jedinstvenih db objekata</span></div>'
                                + '</div>'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#FFF4E5;color:#FD970F;"><i class="fas fa-tags"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">Metadata stavki</span><span class="meta-stat-value">' + allMetaData.length + '</span><span class="meta-stat-sub">Ukupno meta zapisa</span></div>'
                                + '</div>'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#FEF3C7;color:#D97706;"><i class="fas fa-flask"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">FAT</span><span class="meta-stat-value">' + fatCount + '</span><span class="meta-stat-sub">Skripti na FAT okolini</span></div>'
                                + '</div>'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#F3E8FF;color:#7C3AED;"><i class="fas fa-vial"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">UAT</span><span class="meta-stat-value">' + uatCount + '</span><span class="meta-stat-sub">Skripti na UAT okolini</span></div>'
                                + '</div>'
                                + '<div class="dsh-card meta-stat-card">'
                                +   '<div class="meta-stat-icon" style="background:#FEE2E2;color:#DC2626;"><i class="fas fa-rocket"></i></div>'
                                +   '<div class="meta-stat-body"><span class="meta-stat-label">PROD</span><span class="meta-stat-value">' + prodCount + '</span><span class="meta-stat-sub">Skripti na PROD okolini</span></div>'
                                + '</div>'
                                + '</div>';

                            // Object types breakdown
                            if (Object.keys(metaTypeCount).length > 0) {
                                summaryHtml += '<div class="rs-modal-breakdown" style="margin-bottom:12px;"><strong>Tipovi objekata:</strong> ';
                                let types: string[] = [];
                                Object.keys(metaTypeCount).forEach(function (type) {
                                    types.push(type + ' (' + metaTypeCount[type] + ')');
                                });
                                summaryHtml += types.join(', ');
                                summaryHtml += '</div>';
                            }

                            // ── Build Scripts List with Descriptions ──────────────────────
                            let rows = '';
                            scripts.forEach(function (s) {
                                let badges = '';
                                if (s.fat)  badges += '<span class="rs-env-pill rs-env-fat mr-1">FAT</span>';
                                if (s.uat)  badges += '<span class="rs-env-pill rs-env-uat mr-1">UAT</span>';
                                if (s.prod) badges += '<span class="rs-env-pill rs-env-prod">PROD</span>';

                                let description = s.description ? s.description.substring(0, 100) : '';
                                if (s.description && s.description.length > 100) description += '...';

                                let objectsAffected = '';
                                if (s.metaData && s.metaData.length > 0) {
                                    let objNames: string[] = [];
                                    s.metaData.forEach(function (meta: any) {
                                        if (meta.metaName && objNames.indexOf(meta.metaName) === -1) {
                                            objNames.push(meta.metaName);
                                        }
                                    });
                                    objectsAffected = objNames.join(', ');
                                }

                                rows += '<tr>';
                                rows += '<td style="font-weight: 500;">' + s.name + '</td>';
                                rows += '<td>' + (description ? '<small style="color: #fff;">' + description + '</small>' : '<small style="color: #999;">Nema opisa</small>') + '</td>';
                                rows += '<td>' + (objectsAffected ? '<small style="color: #fff;">' + objectsAffected + '</small>' : '<small style="color: #999;">—</small>') + '</td>';
                                rows += '<td style="text-align: right; white-space: nowrap;">' + badges + '</td>';
                                rows += '</tr>';
                            });

                            $('#ScriptDetailsModalBody').html(
                                summaryHtml +
                                '<div class="spc-table-wrap">' +
                                '<table id="calDayTable" class="table table-striped w-100" style="margin-bottom: 0;">' +
                                '<thead><tr><th>Skripta</th><th>Opis</th><th>Objekti</th><th>Env</th></tr></thead>' +
                                '<tbody>' + rows + '</tbody>' +
                                '</table></div>'
                            );

                            Common.DataTableCustom.Init('calDayTable', {
                                paging: true,
                                pageLength: 25,
                                scrollY: '50vh',
                                scrollX: false,
                                order: [[0, 'asc']],
                                info: true
                            }, [{
                                targets: 1,
                                orderable: true,
                                className: 'text-left',
                                width: '35%'
                            }, {
                                targets: 2,
                                orderable: true,
                                className: 'text-left',
                                width: '30%'
                            }, {
                                targets: 3,
                                orderable: false,
                                className: 'text-right',
                                width: '110px'
                            }, {
                                targets: 0,
                                orderable: true,
                                className: 'text-left',
                                width: '25%'
                            }]);
                        },
                        error: function () {
                            $('#ScriptDetailsModalBody').html('<p class="text-danger px-3 py-2">Greška pri učitavanju.</p>');
                        }
                    });
                });
            },
            error: function () {
                $loader.hide();
                $grid.html('<span class="rs-calendar-empty text-danger">Greška pri učitavanju kalendara.</span>').show();
            }
        });
    }

    function applyFilters(): void {
        var dateFrom: string = Common.FormatDate($('#dateFrom').val().toString(), 'en');
        var dateTo: string = Common.FormatDate($('#dateTo').val().toString(), 'en');
        var versionId: string = $("#versionList").val().toString();
        var companyId: string = $("#companyList").val().toString();

        // Persist filter state to cookies (fire-and-forget, no reload needed)
        $.get(`/Script/SaveFilters?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&versionId=${versionId}&companyId=${companyId}`);

        // Reload tab-1 tables with new filter URLs
        if (($.fn.DataTable as any).isDataTable('#scriptDataTable')) {
            $('#scriptDataTable').DataTable().ajax.url(Common.FilterBar.BuildUrl('/Script/ReleasedScriptsListData')).load();
        }
        loadPendingReleases();
        if (($.fn.DataTable as any).isDataTable('#confirmedTable')) {
            $('#confirmedTable').DataTable().ajax.url(Common.FilterBar.BuildUrl('/Script/ReleaseConfirmationListData') + '&confirmed=true').load();
        }
        loadReleaseConfirmStats();

        if (calendarTabInited) {
            loadCalendar();
        }

        // Reload status tab if already initialized
        if (statusTabInited) {
            reloadStatusTab();
        }

        if (rnTabInited) {
            ReleaseNotes.Reload();
        }
    }
}

module ReleaseNotes {

    // ── Public entry point ────────────────────────────────────────────────────
    export function Init(): void {
        initRnTable();
    }

    export function Reload(): void {
        if (($.fn.DataTable as any).isDataTable('#rnPackagesTable')) {
            ($('#rnPackagesTable') as any).DataTable()
                .ajax.url(Common.FilterBar.BuildUrl('/Script/ReleasedNotesListData'))
                .load();
        }
    }

    // ── DataTable ─────────────────────────────────────────────────────────────
    function initRnTable(): void {
        const colDef: DataTables.ColumnDefsSettings[] = [
            { targets: [3, 4], visible: false },
            { targets: 0, className: 'text-left' },
            {
                targets: 2,
                width: '80px',
                className: 'spc-td-actions',
                orderable: false,
                render: function (_data: any, _type: any, row: any[]) {
                    return `<div class='spc-actions-wrap'>`
                         + `<a class='spc-table-action rn-preview-btn' data-file-path='${row[3]}' data-file-name='${row[4]}' title='Pregled'><i class='fas fa-eye spc-action-icon spc-action-icon--preview'></i></a>`
                         + `<a class='spc-table-action rn-download-btn' data-file-path='${row[3]}' data-file-name='${row[4]}' title='Preuzmi'><i class='fas fa-cloud-download-alt spc-action-icon spc-action-icon--download'></i></a>`
                         + `</div>`;
                }
            }
        ];

        Common.DataTableCustom.Init(
            'rnPackagesTable',
            {
                pageLength: 25,
                order: [[1, 'desc']],
                scrollY: '40vh',
                columns: [
                    { data: 0, title: 'Naziv paketa' },
                    { data: 1, title: 'Vrijeme' },
                    { data: 2, title: 'Akcije' },
                    { data: 3, title: '' },
                    { data: 4, title: '' }
                ]
            },
            colDef,
            Common.FilterBar.BuildUrl('/Script/ReleasedNotesListData')
        );

        $('#rnPackagesTable')
            .off('click.rnPreview').on('click.rnPreview', '.rn-preview-btn', function () {
                const filePath = $(this).data('file-path') as string;
                const fileName = $(this).data('file-name') as string;
                openModal(filePath, fileName);
            })
            .off('click.rnDownload').on('click.rnDownload', '.rn-download-btn', function () {
                const filePath = $(this).data('file-path') as string;
                const fileName = $(this).data('file-name') as string;
                const url = '/Script/GetReleaseNotes?filePath=' + encodeURIComponent(filePath)
                          + '&fileName=' + encodeURIComponent(fileName);
                $.get(url, function (md: string) {
                    const blob = new Blob([md], { type: 'text/markdown;charset=utf-8' });
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = 'MD_' + fileName + '.md';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href);
                });
            });
    }

    // ── Modal ─────────────────────────────────────────────────────────────────
    function openModal(filePath: string, fileName: string): void {
        const $modal = $('#ScriptDetailsModal');

        $('#ScriptDetailsModalTitleText').html('<i class="fas fa-file-alt" style="margin-right:6px;color:#378ADD;"></i>Release Notes — ' + esc(fileName));
        $('#ScriptDetailsModalTitleTag').hide().text('');
        $('#btnScriptDetailsModal').hide();
        const $body = $('#ScriptDetailsModalBody');
        $body.html('<div class="rn-modal-loader"><i class="fas fa-spinner fa-spin" style="margin-right:6px;"></i>Učitavanje...</div>');

        $modal.modal({ backdrop: 'static', keyboard: true, show: true }).modal('show');

        $modal.one('hidden.bs.modal', function () {
            $body.empty();
        });

        $.ajax({
            url: '/Script/GetReleaseNotes?filePath=' + encodeURIComponent(filePath)
               + '&fileName=' + encodeURIComponent(fileName),
            type: 'GET',
            success: function (md: string) {
                try {
                    const parsed = rnParse(md);
                    $body.html(rnBuildHtml(parsed));
                    $body.find('.rn-card-header').on('click', function () {
                        $(this).closest('.rn-card').toggleClass('is-open');
                    });
                    $body.find('.rn-full-diff-btn').on('click', function (e) {
                        e.stopPropagation();
                        const idMetaData = $(this).data('id-meta-data');
                        Dialog.OpenModal('<i class="fas fa-exchange-alt" style="margin-right:6px;color:#378ADD;"></i>Razlike skripte', '', `/ScriptMetaData/DiffDetail/${idMetaData}`);
                    });

                    // ── AI summary section (inserted after stats cards) ──────
                    const rnAiBodyId   = 'rnAiBody_'   + fileName.replace(/[^a-zA-Z0-9]/g, '_');
                    const rnAiStatusId = 'rnAiStatus_' + fileName.replace(/[^a-zA-Z0-9]/g, '_');
                    $body.find('.meta-stats').after(
                        '<div class="diff-ai-section" style="margin-top:12px;margin-bottom:12px;">'
                        + '<div class="diff-ai-header"><i class="fas fa-robot" style="margin-right:6px;"></i>AI analiza release nota'
                        + '<span id="' + rnAiStatusId + '" style="margin-left:10px;font-size:11px;font-weight:400;"><i class="fas fa-spinner fa-spin"></i> Priprema...</span>'
                        + '</div>'
                        + '<div class="diff-ai-body ai-streaming" id="' + rnAiBodyId + '"></div>'
                        + '</div>'
                    );
                    const $rnAiStatus = $('#' + rnAiStatusId);
                    const $rnAiBody   = $('#' + rnAiBodyId);
                    const rnAiStatusLabels: { [key: string]: string } = {
                        RunCreated: 'Obrada kreirana', RunQueued: 'U redu čekanja...',
                        RunInProgress: 'Analiziram...', RunStepCreated: 'Korak kreiran',
                        RunStepInProgress: 'Obrada koraka...', MessageCreated: 'Pripremam odgovor...',
                        MessageInProgress: 'Pišem odgovor...', MessageCompleted: 'Poruka dovršena',
                        RunStepCompleted: 'Korak dovršen', RunCompleted: 'Analiza završena'
                    };
                    $.get('/AIScript/PrepareReleaseNoteSummary?filePath=' + encodeURIComponent(filePath) + '&fileName=' + encodeURIComponent(fileName),
                        function (token: string) {
                            const es = new EventSource('/AIScript/ReleaseSummaryStreaming/' + token);
                            let buffer = '';
                            es.onmessage = function (evt: MessageEvent) {
                                const data = JSON.parse(evt.data);
                                if (data.content) {
                                    buffer += data.content;
                                    $rnAiBody.html(buffer);
                                } else {
                                    const label = rnAiStatusLabels[data.updateKind] || data.updateKind;
                                    if (data.updateKind === 'RunCompleted') {
                                        $rnAiBody.removeClass('ai-streaming');
                                        $rnAiStatus.html('<i class="fas fa-check-circle" style="color:#1D9E75;"></i> ' + label);
                                        es.close();
                                    } else {
                                        $rnAiStatus.html('<i class="fas fa-spinner fa-spin" style="color:#378ADD;"></i> ' + label);
                                    }
                                }
                            };
                            es.onerror = function () {
                                es.close();
                                $rnAiStatus.html('<i class="fas fa-exclamation-circle" style="color:#d92d20;"></i> Veza prekinuta');
                                $rnAiBody.removeClass('ai-streaming');
                            };
                        }
                    ).fail(function () {
                        $rnAiStatus.html('<i class="fas fa-exclamation-circle" style="color:#d92d20;"></i> Greška pri pripremi');
                        $rnAiBody.removeClass('ai-streaming');
                    });
                } catch (e) {
                    const msg = (e instanceof Error) ? e.message : String(e);
                    $body.html('<div class="alert alert-danger">Greška pri parsiranju: ' + msg + '</div>');
                }
            },
            statusCode: {
                404: function () {
                    $body.html('<div class="alert alert-warning">Release notes datoteka nije pronađena. Ovaj paket je generiran prije uvođenja release nota.</div>');
                }
            },
            error: function (xhr: JQuery.jqXHR) {
                if (xhr.status !== 404)
                    $body.html('<div class="alert alert-danger">Greška pri učitavanju release nota.</div>');
            }
        });

        $modal.off('hidden.bs.modal.rnCleanup').on('hidden.bs.modal.rnCleanup', function () {
            if ($('.modal.show').length === 0) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open').css({ 'padding-right': '', 'overflow': '' });
            }
        });
    }

    // ── Parser ────────────────────────────────────────────────────────────────
    interface RnHeader { customer: string | null; environment: string | null; releaseDate: string | null; }
    interface RnDiffLine { type: string; content: string; }
    interface RnDiff { comparedWith: string; idMetaData?: number; lines: RnDiffLine[]; }
    interface RnScript { name: string; description: string | null; diff: RnDiff | null; diffAi: string | null; }
    interface RnParsed { header: RnHeader; scripts: RnScript[]; }

    function rnParse(md: string): RnParsed {
        const result: RnParsed = { header: { customer: null, environment: null, releaseDate: null }, scripts: [] };
        const parts = md.split(/\n## Script:\s*/);

        const hdr = parts[0];
        result.header.customer    = rnField(hdr, '**Customer:**');
        result.header.environment = rnField(hdr, '**Environment:**');
        result.header.releaseDate = rnField(hdr, '**Release Date:**');

        for (let i = 1; i < parts.length; i++) {
            const block = parts[i];
            const firstNl = block.indexOf('\n');
            const scriptName = (firstNl >= 0 ? block.substring(0, firstNl) : block).trim();
            result.scripts.push({
                name:        scriptName,
                description: rnField(block, '**Description:**'),
                diff:        rnDiffJson(block),
                diffAi:      rnDiffAi(block)
            });
        }
        return result;
    }

    function rnField(text: string, label: string): string | null {
        const idx = text.indexOf(label);
        if (idx < 0) return null;
        const rest = text.substring(idx + label.length);
        const end = rest.indexOf('\n');
        return (end >= 0 ? rest.substring(0, end) : rest).trim() || null;
    }

    function rnDiffJson(block: string): RnDiff | null {
        const markerIdx = block.indexOf('**Changes (diff):**');
        if (markerIdx < 0) return null;
        const slice = block.substring(markerIdx);
        const fenceOpen = slice.indexOf('```json');
        if (fenceOpen < 0) return null;
        const jsonStart = slice.indexOf('\n', fenceOpen) + 1;
        const fenceClose = slice.indexOf('\n```', fenceOpen + 3);
        if (fenceClose < 0) return null;
        const raw = slice.substring(jsonStart, fenceClose).trim();
        try { return JSON.parse(raw) as RnDiff; } catch (e) { return null; }
    }

    function rnDiffAi(block: string): string | null {
        const label = '**Changes (diff_ai):**';
        const idx = block.indexOf(label);
        if (idx < 0) return null;
        const rest = block.substring(idx + label.length);
        const endIdx = rest.indexOf('\n---');
        const text = (endIdx >= 0 ? rest.substring(0, endIdx) : rest).trim();
        if (!text || text === '_No AI differences recorded._') return null;
        return text;
    }

    // ── HTML builder ──────────────────────────────────────────────────────────
    function rnBuildHtml(parsed: RnParsed): string {
        const h = parsed.header;
        const scripts = parsed.scripts;
        const withDiff = scripts.filter(s => s.diff !== null).length;

        let html = '';

        html += '<div class="meta-stats meta-stats--sm">'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#F0FDF4;color:#16a34a;"><i class="fas fa-building"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Klijent</span><span class="meta-stat-value meta-stat-value--sm">' + esc(h.customer || '—') + '</span></div>'
              + '</div>'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#EFF6FF;color:#378ADD;"><i class="fas fa-server"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Okolina</span><span class="meta-stat-value meta-stat-value--sm">' + esc(h.environment || '—') + '</span></div>'
              + '</div>'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#F5F3FF;color:#7C3AED;"><i class="fas fa-calendar-alt"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Datum</span><span class="meta-stat-value meta-stat-value--sm">' + esc(h.releaseDate || '—') + '</span></div>'
              + '</div>'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#EFF6FF;color:#378ADD;"><i class="fas fa-file-alt"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Skripti ukupno</span><span class="meta-stat-value">' + scripts.length + '</span></div>'
              + '</div>'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#ecfdf3;color:#12b76a;"><i class="fas fa-code-branch"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Sa razlikama</span><span class="meta-stat-value">' + withDiff + '</span></div>'
              + '</div>'
              + '<div class="dsh-card meta-stat-card">'
              +   '<div class="meta-stat-icon" style="background:#FFF4E5;color:#FD970F;"><i class="fas fa-minus-circle"></i></div>'
              +   '<div class="meta-stat-body"><span class="meta-stat-label">Bez razlika</span><span class="meta-stat-value">' + (scripts.length - withDiff) + '</span></div>'
              + '</div>'
              + '</div>';

        scripts.forEach(s => { html += rnCardHtml(s); });

        return html;
    }

    function rnCardHtml(s: RnScript): string {
        const hasDiff = s.diff !== null;
        const badge = hasDiff
            ? '<span class="rn-badge rn-badge--diff">diff</span>'
            : '<span class="rn-badge rn-badge--none">no diff</span>';

        let body = '';
        const descText = (!s.description || s.description === '_No description provided._')
            ? '<em>Nema opisa.</em>' : esc(s.description);
        body += '<div class="rn-desc">' + descText + '</div>';

        if (s.diffAi) {
            body += '<div class="rn-ai-label"><i class="fas fa-robot" style="margin-right:4px;"></i>AI Summary</div>';
            body += '<div class="rn-ai-text">' + esc(s.diffAi) + '</div>';
        }

        if (s.diff) {
            const lines = s.diff.lines || [];
            const nAdd = lines.filter(l => l.type === 'added').length;
            const nRem = lines.filter(l => l.type === 'removed').length;
            body += '<div class="rn-diff-header">'
                  + '<span>Uspoređeno s: <span class="rn-diff-compared">' + esc(s.diff.comparedWith || '—') + '</span></span>'
                  + '<span class="rn-diff-add">+' + nAdd + '</span>'
                  + '<span class="rn-diff-rem">−' + nRem + '</span>'
                  + (s.diff.idMetaData
                        ? '<button type="button" class="rn-full-diff-btn" data-id-meta-data="' + s.diff.idMetaData + '" title="Prikaži pun diff"><i class="fas fa-code-branch"></i> Pun diff</button>'
                        : '')
                  + '</div>';
            if (lines.length) {
                body += '<table class="rn-diff-table">';
                lines.forEach(line => {
                    const add = line.type === 'added';
                    body += '<tr class="' + (add ? 'rn-row-add' : 'rn-row-rem') + '">'
                          + '<td class="rn-marker ' + (add ? 'rn-marker-add' : 'rn-marker-rem') + '">' + (add ? '+' : '−') + '</td>'
                          + '<td class="rn-cell">' + esc(line.content || '') + '</td>'
                          + '</tr>';
                });
                body += '</table>';
            }
        } else {
            body += '<div class="rn-no-diff">Nema evidentiranih razlika.</div>';
        }

        return '<div class="rn-card">'
             + '<div class="rn-card-header">'
             + '<div class="rn-card-left"><span class="rn-card-name">' + esc(s.name) + '</span>' + badge + '</div>'
             + '<i class="fas fa-chevron-down rn-chevron"></i>'
             + '</div>'
             + '<div class="rn-card-body">' + body + '</div>'
             + '</div>';
    }

    function esc(s: string): string {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}